// utils/manejoErrores.js
export const manejarError = (error) => {
  if (error.response) {
    // El servidor respondió con un status fuera del rango 2xx
    const { status, data } = error.response;
    console.error("Error en la respuesta:", data);
    return `Error ${status}: ${data.message || "Ocurrió un error."}`;
  } else if (error.request) {
    // La solicitud fue hecha pero no se recibió respuesta del servidor
    console.error("No se recibió respuesta del servidor.");
    return "No se pudo conectar con el servidor. Intenta más tarde.";
  } else {
    // Otro tipo de error
    console.error("Error inesperado:", error.message);
    return "Ocurrió un error inesperado. Intenta más tarde.";   
  }
};